'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pill = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    border: 2px solid ', ';\n    padding: .5em; \n    background: ', '; \n    border-radius: calc(', ');\n    border: ', ';\n'], ['\n    border: 2px solid ', ';\n    padding: .5em; \n    background: ', '; \n    border-radius: calc(', ');\n    border: ', ';\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _chromaJs = require('chroma-js');

var _chromaJs2 = _interopRequireDefault(_chromaJs);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Pill = exports.Pill = _styledComponents2.default.div(_templateObject, {}, function (_ref) {
  var theme = _ref.theme;
  return theme.background;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.borderRadius;
}, function (_ref3) {
  var theme = _ref3.theme;
  return '1px solid ' + (0, _chromaJs2.default)(theme.middleground).darken(0.5);
});